export const SAVED_ANALYSES_STORAGE_KEY = 'gvi_painel_analises';

export function normalizeSavedAnalysisRecord(type, data = {}, options = {}) {
  const now = options.now instanceof Date ? options.now : new Date();
  const idFactory = typeof options.idFactory === 'function' ? options.idFactory : createSavedAnalysisId;
  const existing = options.existing || {};
  const id = existing.id || data.id || idFactory();
  const isoNow = now.toISOString();

  return {
    id,
    type,
    ...data,
    title: data.title || existing.title || data.label,
    label: data.label || data.title || existing.label,
    dedupeKey: data.dedupeKey || buildAnalysisDedupeKey(type, data),
    storageScope: 'local',
    createdAt: existing.createdAt || data.createdAt || isoNow,
    updatedAt: isoNow,
    date: now.toLocaleString('pt-BR'),
    electionDataDate: data.electionDataDate || data.ano || existing.electionDataDate || '',
  };
}

export function createSavedAnalysisId() {
  return `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
}

export function buildAnalysisDedupeKey(type, data = {}) {
  const candidatos = Array.isArray(data.candidatos)
    ? data.candidatos.map(c => c.id || `${data.cargoKey || ''}_${c.numero || ''}`).filter(Boolean).sort().join(',')
    : '';

  return [
    type,
    data.uf || '',
    normalizeText(data.municipio || ''),
    data.ano || '',
    data.zona || '',
    data.cargoKey || '',
    candidatos
  ].join('|');
}

export function getAnalysisDisplayLabel(analysis) {
  return analysis?.title || analysis?.label || 'Analise sem titulo';
}

export function getAnalysisSubLabel(analysis) {
  const typeLabels = {
    municipio: 'Municipio',
    zona: 'Zona',
    candidato: 'Candidato',
    comparativo: 'Comparativo',
  };
  const parts = [
    typeLabels[analysis?.type] || 'Analise',
    analysis?.storageScope === 'local' ? 'Salva localmente neste navegador' : 'Salvamento local',
    analysis?.electionDataDate ? `Dado eleitoral ${analysis.electionDataDate}` : '',
    analysis?.updatedAt ? `Atualizada em ${formatDateTime(analysis.updatedAt)}` : (analysis?.date || ''),
  ].filter(Boolean);
  return parts.join(' · ');
}

export function buildCopyLabel(label, existingLabels = []) {
  const base = `Copia de ${label}`;
  const labels = new Set(existingLabels);
  if (!labels.has(base)) return base;

  let index = 2;
  let candidate = `Copia ${index} de ${label}`;
  while (labels.has(candidate)) {
    index += 1;
    candidate = `Copia ${index} de ${label}`;
  }
  return candidate;
}

export function slugifyFilename(value) {
  const slug = normalizeText(value)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  return slug || 'gvi';
}

function formatDateTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR');
}

function normalizeText(str) {
  return String(str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}
